/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_History_TitleInputs */

const cs_portals_history_title = /** @type {(inputs: Portals_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historie publikace`)
};

const en_portals_history_title = /** @type {(inputs: Portals_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication history`)
};

/**
* | output |
* | --- |
* | "Publication history" |
*
* @param {Portals_History_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_history_title = /** @type {((inputs?: Portals_History_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_History_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_history_title(inputs)
	return cs_portals_history_title(inputs)
});